export type UploadStage = 'presign' | 's3' | 'confirm' | 'network'

export type Translate = (key: string, params?: Record<string, unknown>) => string

export class UploadError extends Error {
  status: number | null
  code: string | null
  stage: UploadStage
  reference: string

  constructor(message: string, init: { status: number | null; code: string | null; stage: UploadStage; reference: string }) {
    super(message)
    this.name = 'UploadError'
    this.status = init.status
    this.code = init.code
    this.stage = init.stage
    this.reference = init.reference
  }
}

// Solo el <Code> del XML de S3; el resto del cuerpo (claves, firmas) nunca sale de aquí.
export function parseS3ErrorCode(body: string): string | null {
  const match = /<Code>\s*([A-Za-z0-9_.-]{1,64})\s*<\/Code>/.exec(body)
  return match?.[1] ?? null
}

export function buildUploadReference(stage: UploadStage, status: number | null, code: string | null): string {
  const prefix = stage === 's3' || stage === 'network' ? 'S3' : stage.toUpperCase()
  if (stage === 'network') return `${prefix}-NETWORK`
  return [prefix, status, code].filter((part) => part !== null && part !== '').join('-')
}

export function uploadErrorMessageKey(status: number | null, code: string | null, stage: UploadStage): string {
  if (stage === 'network') return 'uploads.errors.network'
  if (status === 413 || code === 'EntityTooLarge') return 'uploads.errors.tooLarge'
  if (status === 415 || code === 'InvalidContentType') return 'uploads.errors.type'
  if (status === 403 || code === 'ExpiredToken' || code === 'RequestTimeTooSkewed') return 'uploads.errors.link'
  return 'uploads.errors.generic'
}

export function createUploadError(
  init: { stage: UploadStage; status: number | null; body?: string },
  t: Translate
): UploadError {
  const code = init.body ? parseS3ErrorCode(init.body) : null
  const reference = buildUploadReference(init.stage, init.status, code)
  const message = t(uploadErrorMessageKey(init.status, code, init.stage), { code: reference })
  return new UploadError(message, { status: init.status, code, stage: init.stage, reference })
}
